(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("HelloBar", [], factory);
	else if(typeof exports === 'object')
		exports["HelloBar"] = factory();
	else
		root["HelloBar"] = factory();
})(window, function() {
return 